import { useHeaderContext } from '@jouzen/ecom-components';
import { useLayoutEffect } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';

import type { WizardImage } from './wizardData/types';

interface StepImageProps {
  readonly image: WizardImage | null | undefined;
}

const StepImage = ({ image }: StepImageProps) => {
  const headerContext = useHeaderContext();
  const setInverse = headerContext?.setInverse;

  const altMsgKey = image?.altMsgKey as MessageKey | undefined;
  const inverseText = image?.inverseText;
  const originalSrc = image?.originalSrc;

  useLayoutEffect(() => {
    setInverse?.(inverseText ?? false);
  }, [inverseText, setInverse]);

  return (
    <div className="w-full bg-gray-150 lg:h-screen">
      {originalSrc && (
        <Image
          className="object-cover"
          fill
          localizedAlt={
            altMsgKey ?? ('pdp_select_style_and_finish' as MessageKey)
          }
          priority
          quality={65}
          sizes="(min-width: 1440px) 100vw, (min-width: 600px) 1024px, (min-width: 400px) 600px, 400px"
          src={originalSrc}
        />
      )}
    </div>
  );
};

export default StepImage;
